import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import OrganizationItemContent from './chatOrganizationItemContent';

function ChatOrganizationItemChildrenTree({
  childOrganizations,
  selectedsOrganizations,
  isActive,
  handleSelectOrganization,
  handleClickOrganization,
  testid
}) {
  const getClassName = useCallback((childOrganization) => {
    if (selectedsOrganizations.includes(childOrganization)) {
      return `child-item checked`;
    }

    return 'child-item';
  }, [selectedsOrganizations]);

  return (
    <div
      data-testid={testid}
      className="children-organizations"
    >
      {childOrganizations.map(({
        organization: childOrganization,
        childOrganizations: childOrganizationGrandSon
      }) => (childOrganizationGrandSon ? (
        <React.Fragment key={childOrganization.id}>
          <OrganizationItemContent
            organization={childOrganization}
            childOrganizations={childOrganizationGrandSon}
            showRightIcon={false}
            selectedsOrganizations={selectedsOrganizations}
            isActive={isActive}
            handleClickOrganization={handleClickOrganization}
            handleSelectOrganization={handleSelectOrganization}
          />
          <ChatOrganizationItemChildrenTree
            testid={`organization-item-children-tree-${childOrganization.key}`}
            childOrganizations={childOrganizationGrandSon}
            isActive={isActive}
            selectedsOrganizations={selectedsOrganizations}
            handleSelectOrganization={handleSelectOrganization}
            handleClickOrganization={handleClickOrganization}
          />
        </React.Fragment>
      ) : (
        <div
          data-testid={`organization-child-item-${childOrganization.key}`}
          key={childOrganization.id}
          className={getClassName(childOrganization)}
          onClick={() => handleSelectOrganization({ organization: childOrganization })}
        >
          <input
            type="checkbox"
            checked={selectedsOrganizations.includes(childOrganization)}
            readOnly
          />
          <div className="info">
            <div className="info">
              <p className="name">{childOrganization.description}</p>
              <p className="region">{childOrganization?.timeZone?.timezoneName || '--'}</p>
            </div>
          </div>
        </div>
      )))}
    </div>
  );
}

ChatOrganizationItemChildrenTree.propTypes = {
  testid: PropTypes.string.isRequired,
  childOrganizations: PropTypes.array,
  selectedsOrganizations: PropTypes.array.isRequired,
  isActive: PropTypes.func.isRequired,
  handleClickOrganization: PropTypes.func.isRequired,
  handleSelectOrganization: PropTypes.func.isRequired
};

export default memo(ChatOrganizationItemChildrenTree);
